import { createAction, props } from '@ngrx/store';
import { IAppeal } from './appeal.interface';
import {
	IModerationCase,
	IModerationDecision,
} from '../+moderation-store/moderation.interface';
import { IResponseError } from '../../service/interface';
import { ISettleAppealRequest } from '../../service/moderation/interface';
import { OrderBy } from '../../../shared/enums';
import { IPagination } from '../shared/interface';

// ── API ──

const loadAppeals = createAction('[Appeal/API] Load Appeals');

const loadAppealsSuccess = createAction(
	'[Appeal/API] Load Appeals Success',
	props<{ appeals: IAppeal[]; pagination: IPagination }>(),
);

const loadAppealsError = createAction(
	'[Appeal/API] Load Appeals Error',
	props<{ error: IResponseError }>(),
);

const loadAppeal = createAction(
	'[Appeal/API] Load Appeal',
	props<{ appealId: string }>(),
);

const loadAppealSuccess = createAction(
	'[Appeal/API] Load Appeal Success',
	props<{ appeal: IAppeal }>(),
);

const loadAppealError = createAction(
	'[Appeal/API] Load Appeal Error',
	props<{ error: IResponseError }>(),
);

const loadContestedDecision = createAction(
	'[Appeal/API] Load Contested Decision',
	props<{ decisionId: string }>(),
);

const loadContestedDecisionSuccess = createAction(
	'[Appeal/API] Load Contested Decision Success',
	props<{ decision: IModerationDecision }>(),
);

const loadContestedDecisionError = createAction(
	'[Appeal/API] Load Contested Decision Error',
	props<{ error: IResponseError }>(),
);

const loadContestedCase = createAction(
	'[Appeal/API] Load Contested Case',
	props<{ caseId: string }>(),
);

const loadContestedCaseSuccess = createAction(
	'[Appeal/API] Load Contested Case Success',
	props<{ moderationCase: IModerationCase }>(),
);

const loadContestedCaseError = createAction(
	'[Appeal/API] Load Contested Case Error',
	props<{ error: IResponseError }>(),
);

const settleAppeal = createAction(
	'[Appeal/API] Settle Appeal',
	props<{ appealId: string; body: ISettleAppealRequest }>(),
);

const settleAppealSuccess = createAction(
	'[Appeal/API] Settle Appeal Success',
	props<{ appeal: IAppeal }>(),
);

const settleAppealError = createAction(
	'[Appeal/API] Settle Appeal Error',
	props<{ error: IResponseError }>(),
);

// ── UI ──

const setOffset = createAction(
	'[Appeal/UI] Set Offset',
	props<{ offset: number }>(),
);

const setLimit = createAction(
	'[Appeal/UI] Set Limit',
	props<{ limit: number }>(),
);

const setSortOrder = createAction(
	'[Appeal/UI] Set SortBy OrderBy',
	props<{ sortBy: string; orderBy: OrderBy }>(),
);

const clearSortOrder = createAction('[Appeal/UI] Clear SortBy OrderBy');

const setFilter = createAction(
	'[Appeal/UI] Set Appeal Filter',
	props<{
		data: {
			[key: string]: string | number | undefined | string[];
		};
	}>(),
);

const clearAppealDetail = createAction('[Appeal/UI] Clear Appeal Detail');

const clearAppealError = createAction('[Appeal/UI] Clear Appeal Error');

export const AppealActions = {
	// API
	loadAppeals,
	loadAppealsSuccess,
	loadAppealsError,
	loadAppeal,
	loadAppealSuccess,
	loadAppealError,
	loadContestedDecision,
	loadContestedDecisionSuccess,
	loadContestedDecisionError,
	loadContestedCase,
	loadContestedCaseSuccess,
	loadContestedCaseError,
	settleAppeal,
	settleAppealSuccess,
	settleAppealError,
	// UI
	setOffset,
	setLimit,
	setSortOrder,
	clearSortOrder,
	setFilter,
	clearAppealDetail,
	clearAppealError,
};
